import type { NodeMock, StatePreset } from "../mock-types";
import { CHAR_POOL, getPlayerTeam } from "../mock-utils";

export const characterBanMock: NodeMock = {
  label: "Character Ban",
  description: "Teams ban characters from the pool",
  state: (_players, teamCount) => {
    const pool = [
      { id: "char_1", name: "Reaper", imageUrl: "https://picsum.photos/seed/reaper/200/267" },
      { id: "char_2", name: "Phoenix", imageUrl: "https://picsum.photos/seed/phoenix/200/267" },
      { id: "char_3", name: "Wraith", imageUrl: "https://picsum.photos/seed/wraith/200/267" },
      { id: "char_4", name: "Titan", imageUrl: "https://picsum.photos/seed/titan/200/267" },
      { id: "char_5", name: "Spectre", imageUrl: "https://picsum.photos/seed/spectre/200/267" },
      { id: "char_6", name: "Valkyrie", imageUrl: "https://picsum.photos/seed/valkyrie/200/267" },
      { id: "char_7", name: "Shadow", imageUrl: "https://picsum.photos/seed/shadow/200/267" },
      { id: "char_8", name: "Ember", imageUrl: "https://picsum.photos/seed/ember/200/267" },
      { id: "char_9", name: "Storm", imageUrl: "https://picsum.photos/seed/storm/200/267" },
      { id: "char_10", name: "Frost", imageUrl: "https://picsum.photos/seed/frost/200/267" },
      { id: "char_11", name: "Venom" },
      { id: "char_12", name: "Nova" },
    ];
    const bansByTeam: Record<number, string[]> = {};
    for (let t = 0; t < teamCount; t++) bansByTeam[t] = [];
    bansByTeam[0] = ["char_3"];
    if (teamCount >= 2) bansByTeam[1] = ["char_7"];
    const bannedCharacters = Object.values(bansByTeam).flat();
    return {
      characterPool: pool,
      bannedCharacters,
      bansByTeam,
      currentTeam: teamCount >= 3 ? 2 : 0,
      currentBanIndex: bannedCharacters.length,
      totalBansRequired: teamCount * 2,
    };
  },
  config: {
    timeoutSecondsPerBan: 30,
    bansPerTeam: 2,
    banOrder: "alternating",
    labels: {
      title: "Character Ban Phase",
    },
  },
};

export const characterBanPresets: StatePreset[] = [
  {
    label: "Fresh",
    build: ({ teamCount }) => {
      const bansByTeam: Record<number, string[]> = {};
      for (let t = 0; t < teamCount; t++) bansByTeam[t] = [];
      return {
        state: {
          characterPool: CHAR_POOL,
          bannedCharacters: [],
          bansByTeam,
          currentTeam: 0,
          currentBanIndex: 0,
          totalBansRequired: teamCount * 2,
        },
      };
    },
  },
  {
    label: "Your Turn",
    build: ({ players, viewerId, teamCount }) => {
      const viewerTeam = getPlayerTeam(players, viewerId, teamCount);
      const bansByTeam: Record<number, string[]> = {};
      for (let t = 0; t < teamCount; t++) bansByTeam[t] = t < viewerTeam ? ["char_3"] : [];
      const bannedCharacters = Object.values(bansByTeam).flat();
      return {
        state: {
          characterPool: CHAR_POOL,
          bannedCharacters,
          bansByTeam,
          currentTeam: viewerTeam,
          currentBanIndex: bannedCharacters.length,
          totalBansRequired: teamCount * 2,
        },
      };
    },
  },
  {
    label: "Complete",
    build: ({ teamCount }) => {
      const charIds = CHAR_POOL.map((c) => c.id);
      const bansByTeam: Record<number, string[]> = {};
      let idx = 0;
      for (let t = 0; t < teamCount; t++) {
        bansByTeam[t] = [];
        for (let b = 0; b < 2 && idx < charIds.length - 2; b++) {
          bansByTeam[t].push(charIds[idx]!);
          idx++;
        }
      }
      const bannedCharacters = Object.values(bansByTeam).flat();
      return {
        state: {
          characterPool: CHAR_POOL,
          bannedCharacters,
          bansByTeam,
          currentTeam: 0,
          currentBanIndex: bannedCharacters.length,
          totalBansRequired: bannedCharacters.length,
        },
      };
    },
  },
];
